import { ArrayUtils, engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { GameManager } from "../../Managers/GameManager";
import { PickController } from "./PickController";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { PlayList } from "../../Components/Sounds/PlayList";
import { Tweens } from "../../Components/Effects/Tweens";
import { BaseView } from "../Base/BaseView";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { WinAnimatorPick } from "../../CustomComponents/WinAnimatorPick";
import { StageController } from "../../Components/StageController";
import { ImageTextCounterElement } from "../../Components/Elements/Texts/ImageTextCounterElement";
import { AmbientBackground } from "../../Utils/AmbientBackground";

var PickRoundSpotStatus = Communication.Game.PickRoundSpotStatus;
var PickRoundSpotValueType = Communication.Game.PickRoundSpotValueType;

@engineComponent(ComponentTypes.DisplayObject)
export class PickView extends ContainerElement {
    public static ActualValue: number = 0; // todo ???
    public static ActualValueType: string = "";

    private _controller: PickController;

    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;
    private _pickMessageEndnDelay: FrameTimerEventEmitter;
    private _continueDelay: FrameTimerEventEmitter;
    private _continueFinishedDelay: FrameTimerEventEmitter;
    private _finishWinCalculationDelay: FrameTimerEventEmitter;
    private _finishPickInfoWinNumber: FrameTimerEventEmitter;
    private _finishPickInfoMultiplierNumber: FrameTimerEventEmitter;
    private _playMultiplierWinSound: FrameTimerEventEmitter;

    private spots: Array<SwitchElement> = [];
    private spotsContainer: ContainerElement;
    private spotsWinShape: SwitchElement;
    private spotsWinValues: SwitchElement;
    private spotsWinValuesCounters: Array<ImageTextCounterElement> = [];
    private spotsNoWinValuesCounters: Array<ImageTextCounterElement> = [];
    private multipliers: Array<SwitchElement> = [];
    private multipliersContainer: ContainerElement;
    private multipliersWinShape: SwitchElement;
    private multipliersWinValues: SwitchElement;
    private multipliersWinValuesCounters: Array<ImageTextCounterElement> = [];
    private multipliersNoWinValuesCounters: Array<ImageTextCounterElement> = [];
    private _winAnimator: WinAnimatorPick;
    private _logo: SwitchElement;
    private machineTop: ContainerElement;
    private fireflies: ContainerElement;
    private background: ContainerElement;
    private teasingEyesContainer: ContainerElement;
    private foregroundContainer: ContainerElement;
    private transitionScreenContainer: ContainerElement;
    private jackContainer: ContainerElement;
    private logoContainer: ContainerElement;
    private bonusTable: SwitchElement;
    private pickInfoContainer: ContainerElement;
    private pickInfoWinNumber: ImageTextCounterElement;
    private pickInfoMultiplierNumber: ImageTextCounterElement;

    private messageContainer: ContainerElement;
    private messageWin: ImageTextCounterElement;
    private messageMultiplier: ImageTextCounterElement;
    private messageTotalWin: ImageTextCounterElement;

    private _pickMessageStart: HTMLElement;
    private _pickMessageEnd: HTMLElement;
    private _bonusTable: HTMLElement;

    constructor() {
        super();

        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        this._pickMessageEndnDelay = CreateFrameTimer("pickMessageEndDelay");
        this._pickMessageEndnDelay.on(FrameTimerEvents.Complete, this.pickMessageEndnDelay.bind(this));

        this._continueDelay = CreateFrameTimer("continueDelay");
        this._continueDelay.on(FrameTimerEvents.Complete, this.continue.bind(this));

        this._continueFinishedDelay = CreateFrameTimer("continueFinishedDelay");
        this._continueFinishedDelay.on(FrameTimerEvents.Complete, this.continueFinished.bind(this));

        this._finishWinCalculationDelay = CreateFrameTimer("finishWinCalculationDelay");
        this._finishWinCalculationDelay.on(FrameTimerEvents.Complete, this.finishWinCalculation.bind(this));

        this._finishPickInfoWinNumber = CreateFrameTimer("finishPickInfoWinNumber");
        this._finishPickInfoWinNumber.on(FrameTimerEvents.Complete, this.finishPickInfoWinNumber.bind(this));

        this._finishPickInfoMultiplierNumber = CreateFrameTimer("finishPickInfoWinNumber");
        this._finishPickInfoMultiplierNumber.on(
            FrameTimerEvents.Complete,
            this.finishPickInfoMultiplierNumber.bind(this),
        );

        this._playMultiplierWinSound = CreateFrameTimer("playMultiplierWinSound");
        this._playMultiplierWinSound.on(FrameTimerEvents.Complete, this.playMultiplierWinSound.bind(this));

        StageController.pickStageContainer = this;

        this._winAnimator = new WinAnimatorPick();
    }

    createByNode(node: Element): void {
        super.createByNode(node);

        if (this.childs != null) {
            for (let key in this.childs) {
                if (key === "Spots" && this.childs[key] instanceof ContainerElement) {
                    this.spotsContainer = this.childs[key];

                    for (let i = 0; i < 6; i++) {
                        let spot: SwitchElement = <any>this.spotsContainer.children[i];
                        this.spots.push(spot);
                    }
                    let winShape: SwitchElement = <any>this.spotsContainer.childs["WinShape"];
                    this.spotsWinShape = winShape;
                }

                if (key === "SpotsNumbers" && this.childs[key] instanceof SwitchElement) {
                    this.spotsWinValues = this.childs[key];
                    for (let i = 0; i < 5; i++) {
                        let spot: SwitchElement = <any>this.spotsWinValues.getChildElementByName("Spot_" + i);
                        let winValue: ImageTextCounterElement = <any>spot.getChildElementByName("MultiplierNumber");
                        let noWinValue: ImageTextCounterElement = <any>spot.getChildElementByName("NoWinValue");
                        this.spotsWinValuesCounters.push(winValue);
                        this.spotsNoWinValuesCounters.push(noWinValue);
                    }
                }

                if (key === "Multipliers" && this.childs[key] instanceof ContainerElement) {
                    this.multipliersContainer = this.childs[key];

                    for (let i = 0; i < this.multipliersContainer.children.length; i++) {
                        let multiplier: SwitchElement = <any>this.multipliersContainer.children[i];
                        this.multipliers.push(multiplier);
                    }
                    let multipliersWinShape: SwitchElement = <any>this.multipliersContainer.childs["WinShape"];
                    this.multipliersWinShape = multipliersWinShape;
                }

                if (key === "MultipliersNumber" && this.childs[key] instanceof SwitchElement) {
                    this.multipliersWinValues = this.childs[key];

                    for (let i = 0; i < 2; i++) {
                        let spot: SwitchElement = <any>(
                            this.multipliersWinValues.getChildElementByName("Multiplier_" + i)
                        );
                        let winValue: ImageTextCounterElement = <any>spot.getChildElementByName("MultiplierNumber");
                        let noWinValue: ImageTextCounterElement = <any>spot.getChildElementByName("NoWinValue");
                        this.multipliersWinValuesCounters.push(winValue);
                        this.multipliersNoWinValuesCounters.push(noWinValue);
                    }
                }

                if (key === "MachineTopBonus" && this.childs[key] instanceof ContainerElement) {
                    this.machineTop = this.childs[key];
                }

                if (key === "BackgroundBonus" && this.childs[key] instanceof ContainerElement) {
                    this.background = this.childs[key];
                }

                if (key === "TeasingEyesContainer" && this.childs[key] instanceof ContainerElement) {
                    this.teasingEyesContainer = this.childs[key];
                }

                if (key === "FirefliesBonus" && this.childs[key] instanceof ContainerElement) {
                    this.fireflies = this.childs[key];
                }

                if (key === "ForegroundContainer" && this.childs[key] instanceof ContainerElement) {
                    // todo ??
                    this.foregroundContainer = this.childs[key];
                }

                if (key === "MessageContainer" && this.childs[key] instanceof ContainerElement) {
                    this.messageContainer = this.childs[key];
                }

                if (key === "TransitionScreenContainer" && this.childs[key] instanceof ContainerElement) {
                    this.transitionScreenContainer = this.childs[key];
                }

                if (key === "JackContainer" && this.childs[key] instanceof ContainerElement) {
                    this.jackContainer = this.childs[key];
                }

                if (key === "LogoContainer" && this.childs[key] instanceof ContainerElement) {
                    this.logoContainer = this.childs[key];
                }

                if (key === "BonusTable" && this.childs[key] instanceof SwitchElement) {
                    this.bonusTable = this.childs[key];
                    let container: ContainerElement = <any>this.bonusTable.children[0];
                    this.pickInfoWinNumber = container.childs["WinNumber"];
                    this.pickInfoMultiplierNumber = container.childs["MultiplierNumber"];
                }
            }
        }

        this._pickMessageStart = document.getElementById("pickMessageStart");
        this._pickMessageEnd = document.getElementById("pickMessageEnd");
        this._bonusTable = document.getElementById("bonusTable");

        if (DEBUG) {
            if (this._pickMessageStart == null) {
                this.log("ERROR no pickMessageStart");
            }
        }
    }

    initReceived(controller: PickController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;

        if (this.spots != null) {
            if (GameManager.pickResponse != null) {
                if (this._winAnimator != null) {
                    this._winAnimator.on(WinAnimatorPick.FinishWinCalculation, this.finishWinCalculation.bind(this));
                    this._winAnimator.on(WinAnimatorPick.FinishWinAnimator, this.finishWinAnimator.bind(this));
                    this._winAnimator.initializeCustom(
                        this.spots,
                        this.spotsWinValues,
                        this.spotsWinValuesCounters,
                        this.spotsNoWinValuesCounters,
                        this.multipliers,
                        this.multipliersWinValues,
                        this.multipliersWinValuesCounters,
                        this.multipliersNoWinValuesCounters,
                        this.spotsWinShape,
                        this.spotsContainer,
                        this.multipliersContainer,
                        this.multipliersWinShape,
                        this.pickInfoWinNumber,
                        this.pickInfoMultiplierNumber,
                        this.bonusTable,
                    );
                    if (GameManager.pickResponse.round != null && GameManager.pickResponse.round.spots != null) {
                        this._winAnimator.showSpots(GameManager.pickResponse.round.spots);
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no pick response");
                }
            }
        }

        this.visible = false;
    }

    disableLogo(): void {
        if (this._logo != null) {
            this.removeChild(this._logo);
        }
    }

    initIntro(): void {
        this.visible = true;
        StageController.baseStage = false;
        StageController.baseStageContainer.visible = false;
        StageController.freespinsStageContainer.visible = false;

        this.background.addChild(BaseView.Background);
        if (this.teasingEyesContainer != null) {
            this.teasingEyesContainer.addChild(BaseView.TeasingEyes);
        }
        this.fireflies.addChild(BaseView.FireFlies);
        this.machineTop.addChild(BaseView.MachineTop);
        this.messageContainer.addChild(BaseView.Message);
        this.foregroundContainer.addChild(BaseView.Foreground);
        this.transitionScreenContainer.addChild(BaseView.TransitionScreen);
        this.jackContainer.addChild(BaseView.Jack);
        this.logoContainer.addChild(BaseView.Logo);

        this.pickInfoWinNumber.alpha = 0;
        this.pickInfoMultiplierNumber.alpha = 0;

        this.fireflies.alpha = 0;
        this.fireflies.visible = false;
        BaseView.Logo.goToCase("BONUS");

        if (this._bonusTable != null && this._bonusTable.classList.contains(HtmlController.DisabledClass)) {
            this._bonusTable.classList.remove(HtmlController.DisabledClass);
        }

        PlayList.loop("SND_BonusLoop");

        if (GameManager.pickResponse.round.remainingPicks == 2) {
            AmbientBackground.changeAmbientBackground("m1", 0);
            BaseView.Jack.goToCase("BONUS");
            BaseView.Background.goToCase("BONUS");
            BaseView.Foreground.goToCase("BONUS");
            BaseView.MachineTop.goToCase("BONUS");
            BaseView.Message.goToCase("EMPTY");
            this.bonusTable.goToCase("BONUS_1");
            this.childs["SpotsNumbers"].position.x = 0;
            this._winAnimator.idleSpots();
            this._winAnimator.startIdleJack();
            this.spotsContainer.visible = true;
            this.multipliersContainer.visible = false;
        } else {
            AmbientBackground.changeAmbientBackground("m2", 0);
            BaseView.Jack.goToCase("BONUS_MULTIPLIER");
            BaseView.Background.goToCase("BONUS_MULTIPLIER");
            BaseView.Foreground.goToCase("BONUS_MULTIPLIER");
            BaseView.MachineTop.goToCase("BONUS_MULTIPLIER");
            BaseView.Message.goToCase("EMPTY");
            this.bonusTable.goToCase("BONUS_2");
            this.childs["SpotsNumbers"].position.x = 0;
            this._winAnimator.idleMultipliers();
            this.spotsContainer.visible = false;
        }

        let cash: SwitchElement = <any>BaseView.Message.getChildElementByName("Cash");
        let multiplier: SwitchElement = <any>BaseView.Message.getChildElementByName("Multiplier");
        let totalCash: SwitchElement = <any>BaseView.Message.getChildElementByName("TotalCash");

        this.messageWin = <any>cash.getChildElementByName("MultiplierNumber");
        this.messageMultiplier = <any>multiplier.getChildElementByName("MultiplierNumber");
        this.messageTotalWin = <any>totalCash.getChildElementByName("MultiplierNumber");
        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            //PlayList.loop('SND_FSpickupMusic');
            this.visible = true;

            this.enabledSpots();
            //this._controller.selectComplete();
            this._winAnimator.showInitWins(
                [],
                null,
                GameManager.pickResponse.round.spots,
                GameManager.pickResponse.round.remainingPicks,
            );
        }

        if (GameManager.pickResponse.round.remainingPicks === 0) {
            if (this._pickMessageEnd != null && this._pickMessageEnd.classList.contains(HtmlController.DisabledClass)) {
                this._pickMessageEnd.classList.remove(HtmlController.DisabledClass);
                this._pickMessageEnd.classList.add("init");

                if (this._bonusTable != null) {
                    this._bonusTable.classList.add(HtmlController.DisabledClass);
                }

                this.bonusTable.goToCase("EMPTY");
                BaseView.Message.goToCase("END_MESSAGE_WIN_BONUS");
                BaseView.Jack.goToCase("BASE_WAITING");
                this.countMessageValues(true);
                this._winAnimator.startIdleJack();

                PlayList.loop("SND_FSWait");
                PlayList.stop("SND_BaseRecapLoop");
            }

            PlayList.stop("SND_BonusLoop");
        }

        let initSpotsIndexes = [1, 3, 0, 4, 2];

        for (let i = 0; i < initSpotsIndexes.length; i++) {
            this.spotsContainer.setChildIndex(this.spotsContainer.childs["Spot_" + initSpotsIndexes[i]], i);
        }
    }

    collect(): void {}

    start(): void {}

    /**
     *
     * @param spotId
     */
    select(spotId: number): void {
        this._winAnimator.stopTimer();
        if (GameManager.pickResponse.round.remainingPicks === 1) {
            BaseView.Jack.goToCase("TENSE_START_LAST");
            PlayList.play("SND_BonusSelectMushroom");
            PlayList.play("SND_JackLampOff");
        } else {
            BaseView.Jack.goToCase("TENSE_START");
            PlayList.play("SND_BonusSelectRoot");
        }
    }

    end(): void {}

    startReceived(): void {
        //PlayList.stop('SND_FSTransitionMenu');
        //PlayList.play('SND_FSTransitionSelect');
        if (
            this._pickMessageStart != null &&
            !this._pickMessageStart.classList.contains(HtmlController.DisabledClass)
        ) {
            this._pickMessageStart.classList.add(HtmlController.DisabledClass);
            BaseView.Message.goToCase("EMPTY");
            PlayList.play("SND_BaseMessageOut");
        }
    }

    selectReceived(): void {
        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            // Set spots to correspond case
            this._winAnimator.setSpotsData(GameManager.pickResponse.round.spots);
            // Show win/s
            this._winAnimator.showPickWins(GameManager.pickResponse.round);
        }
    }

    endReceived(): void {
        //PlayList.play('SND_FSWin');
        //PlayList.stop('SND_FSpickupMusic');
        //PlayList.loop('SND_BonusLoop');
    }

    finishWinCalculation(): void {
        if (GameManager.pickResponse.round.remainingPicks === 1) {
            PlayList.stop("SND_BonusCreditboxLoop");
            PlayList.play("SND_BonusCreditboxEnd");
        } else {
            PlayList.stop("SND_BonusMessageCreditboxLoop");
            PlayList.play("SND_BonusMessageCreditboxEnd");
        }

        this._controller.winCalculationFinished();
    }

    finishWinAnimator(): void {
        this._controller.allWinsFinished();
        if (GameManager.pickResponse.round.remainingPicks === 0) {
            this.pickInfoMultiplierNumber.alpha = 1;
            this._pickMessageEndnDelay.start(60);
            BaseView.Jack.goToCase("BASE_WAITING");
        } else {
            BaseView.Jack.goToCase("TO_BONUS_MULTIPLIER");
            this._continueDelay.start(140);
            this._winAnimator.stopTimer();
        }
    }

    continue(): void {
        this._controller.continue();

        AmbientBackground.changeAmbientBackground("m2", 430, 4000);

        BaseView.Logo.goToCase("BONUS_HIDE");
        BaseView.Background.goToCase("TO_BONUS_MULTIPLIER");
        BaseView.Foreground.goToCase("TO_BONUS_MULTIPLIER");
        BaseView.MachineTop.goToCase("TO_BONUS_MULTIPLIER");
        this.bonusTable.goToCase("BONUS_1_HIDE");

        PlayList.play("SND_BaseMessageOut");

        if (this._bonusTable != null && !this._bonusTable.classList.contains(HtmlController.DisabledClass)) {
            this._bonusTable.classList.add(HtmlController.DisabledClass);
        }

        this._winAnimator.showSpots(GameManager.pickResponse.round.spots);

        let tweenValues: Array<number> = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;1;0"));
        let tweenDuration: Array<number> = ArrayUtils.numberArray("30;60");
        let tweenEase: Array<string> = ArrayUtils.stringArray("linear");
        let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

        Tweens.removeTweens(this.childs["Spots"], "all");
        tweenValues = [0, 0, -this.childs["Spots"].transitionPositionY];
        Tweens.customTween(this.childs["Spots"], {
            tween: "position.y",
            tweenValues,
            tweenEase: ["linear"],
            tweenDuration: [106, 160],
            tweenDelay: [0],
            tweenLoop: false,
        });

        Tweens.removeTweens(this.childs["SpotsNumbers"], "all");
        tweenValues = [0, 0, -this.childs["Spots"].transitionPositionY];
        Tweens.customTween(this.childs["SpotsNumbers"], {
            tween: "position.y",
            tweenValues,
            tweenEase: ["linear"],
            tweenDuration: [106, 160],
            tweenDelay: [0],
            tweenLoop: false,
        });

        Tweens.removeTweens(this.childs["Multipliers"], "all");
        tweenValues = [this.childs["Spots"].transitionPositionY, this.childs["Spots"].transitionPositionY, 0];
        Tweens.customTween(this.childs["Multipliers"], {
            tween: "position.y",
            tweenValues,
            tweenEase: ["linear"],
            tweenDuration: [106, 160],
            tweenDelay: [0],
            tweenLoop: false,
        });

        Tweens.removeTweens(this.childs["MultipliersNumber"], "all");
        tweenValues = [this.childs["Spots"].transitionPositionY, this.childs["Spots"].transitionPositionY, 0];
        Tweens.customTween(this.childs["MultipliersNumber"], {
            tween: "position.y",
            tweenValues,
            tweenEase: ["linear"],
            tweenDuration: [106, 160],
            tweenDelay: [0],
            tweenLoop: false,
        });

        // Tweens.removeTweens(this.pickInfoContainer,'all');
        // tweenValues = [this.childs['Spots'].transitionPositionY,this.childs['Spots'].transitionPositionY, 0];
        // Tweens.customTween(this.pickInfoContainer, {tween:'position.y', tweenValues, tweenEase:["linear"], tweenDuration:[226,300], tweenDelay: [0], tweenLoop: false});
        this.pickInfoWinNumber.alpha = 1;
        this._winAnimator.setSpotValue();
        this.pickInfoMultiplierNumber.alpha = 0;

        this.multipliersContainer.visible = true;

        this._continueFinishedDelay.start(580);
        // this._continueFinishedDelay.start(526)
    }

    continueFinished(): void {
        this._winAnimator.startIdleJack("MULTIPLIER");
        this._winAnimator.idleMultipliers();
        BaseView.Logo.goToCase("BONUS_SHOW");
        this.bonusTable.goToCase("BONUS_2_SHOW");
        PlayList.play("SND_BaseMessageIn");

        this.childs["Spots"].position.y = -this.childs["Spots"].transitionPositionY;
        this.childs["Spots"].position.x = 0;
        this.childs["SpotsNumbers"].position.y = -this.childs["Spots"].transitionPositionY;
        this.childs["SpotsNumbers"].position.x = 0;

        this.childs["Multipliers"].position.y = 0;
        this.childs["Multipliers"].position.x = 0;
        this.childs["MultipliersNumber"].position.y = 0;
        this.childs["MultipliersNumber"].position.x = 0;

        this.spotsContainer.visible = false;

        if (this._bonusTable != null && this._bonusTable.classList.contains(HtmlController.DisabledClass)) {
            this._bonusTable.classList.remove(HtmlController.DisabledClass);
        }

        this._controller.continueFinished();
    }

    pickMessageEndnDelay(): void {
        if (this._pickMessageEnd != null && this._pickMessageEnd.classList.contains(HtmlController.DisabledClass)) {
            this._pickMessageEnd.classList.remove(HtmlController.DisabledClass);
            PlayList.play("SND_BaseMessageIn");
            PlayList.loop("SND_FSWait");
            PlayList.stop("SND_BonusLoop", 10);
            BaseView.Message.goToCase("END_MESSAGE_WIN_BONUS");
            this.countMessageValues();
            this._winAnimator.startIdleJack();
        }
    }

    countMessageValues(isInit: boolean = false): void {
        let win: number = 0;
        let multiplier: number = 0;

        for (let i = 0; i < GameManager.pickResponse.round.spots.length; i++) {
            if (GameManager.pickResponse.round.spots[i].status === PickRoundSpotStatus.Revealed) {
                if (GameManager.pickResponse.round.spots[i].valueType === PickRoundSpotValueType.Cash) {
                    win = GameManager.pickResponse.round.spots[i].value;
                }

                if (GameManager.pickResponse.round.spots[i].valueType === PickRoundSpotValueType.Multiplier) {
                    multiplier = GameManager.pickResponse.round.spots[i].value;
                }
            }
        }

        let duration: number = 0;
        if (!isInit) {
            duration = 60;
        }

        if (isInit) {
            this.messageWin.start(win, win, 1);
            this.messageMultiplier.start(multiplier, multiplier, 1);
            this.messageTotalWin.start(GameManager.pickResponse.totalWin, GameManager.pickResponse.totalWin, 1);
        } else {
            let msgs1: Array<Element> = <any>this._pickMessageEnd.getElementsByClassName("msg_1");

            for (let i = 0; i < msgs1.length; i++) {
                msgs1[i].classList.add("start");
            }

            this.pickInfoWinNumber.start(win, 0, duration);
            this._finishPickInfoWinNumber.start(duration);

            this.messageWin.start(0, win, duration);
            this.messageMultiplier.start(1, 1, 1);
            Tweens.removeTweens(this.messageMultiplier, "all");
            Tweens.removeTweens(this.messageMultiplier, "changeMessageMultiplierNumber");
            this.messageMultiplier.alpha = 0;
            this.messageTotalWin.alpha = 0;
            PlayList.loop("SND_BonusCreditboxLoop");
        }
    }

    finishPickInfoWinNumber(): void {
        PlayList.stop("SND_BonusCreditboxLoop");
        PlayList.play("SND_BonusCreditboxEnd");
        this.pickInfoWinNumber.alpha = 0;

        let multiplier: number = 0;

        for (let i = 0; i < GameManager.pickResponse.round.spots.length; i++) {
            if (GameManager.pickResponse.round.spots[i].status === PickRoundSpotStatus.Revealed) {
                if (GameManager.pickResponse.round.spots[i].valueType === PickRoundSpotValueType.Multiplier) {
                    multiplier = GameManager.pickResponse.round.spots[i].value;
                }
            }
        }

        Tweens.removeTweens(this.messageMultiplier, "all");
        this.messageMultiplier.start(1, 1, 0);
        this.messageMultiplier.alpha = 1;

        let msgs2: Array<Element> = <any>this._pickMessageEnd.getElementsByClassName("msg_2");

        for (let i = 0; i < msgs2.length; i++) {
            if (!msgs2[i].classList.contains("start")) {
                msgs2[i].classList.add("start");
            }
        }

        this.changeMessageMultiplierNumber(1, multiplier, 5, 0, 0);

        let finalValueDelay = 0;
        for (let i = 0; i < multiplier; i++) {
            finalValueDelay = finalValueDelay + 5 + i;
        }

        this._finishPickInfoMultiplierNumber.start(finalValueDelay);

        this._winAnimator.stopTimer();
        BaseView.Jack.goToCase("BONUS_FINISHED");
        this._winAnimator.startIdleJack();
    }

    finishPickInfoMultiplierNumber(): void {
        // this.pickInfoMultiplierNumber.alpha = 0;

        this.bonusTable.goToCase("BONUS_2_HIDE");
        PlayList.play("SND_BaseMessageOut");

        if (this._bonusTable != null) {
            this._bonusTable.classList.add(HtmlController.DisabledClass);
        }

        let tweenEase: Array<string> = ArrayUtils.stringArray("linear");
        let tweenDelay: Array<number> = ArrayUtils.numberArray("0");
        Tweens.removeTweens(this.messageTotalWin, "all");
        let tweenDuration: Array<number> = [15];
        let tweenValues: Array<number> = this.formatTweenValues("alpha", ArrayUtils.stringArray("0;1"));
        Tweens.customTween(this.messageTotalWin, {
            tween: "alpha",
            tweenValues,
            tweenEase,
            tweenDuration,
            tweenDelay,
            tweenLoop: false,
        });

        this.messageTotalWin.start(0, GameManager.pickResponse.totalWin, 120);

        let msgs3: Array<Element> = <any>this._pickMessageEnd.getElementsByClassName("msg_3");

        for (let i = 0; i < msgs3.length; i++) {
            msgs3[i].classList.add("start");
        }

        PlayList.loop("SND_BonusMessageCreditboxLoop");
        this._finishWinCalculationDelay.start(120);
    }

    changeMessageMultiplierNumber(
        actualCounter: number,
        finalCounter: number,
        duration: number,
        firstDelay: number = 0,
        finalDelay: number,
    ): void {
        if (actualCounter <= finalCounter) {
            let delay = finalDelay + firstDelay + duration;
            let tweenValues: Array<number> = this.formatTweenValues("scale.x", ArrayUtils.stringArray("1;1.5;1"));
            let tweenDuration: Array<number> = [duration / 4, duration / 4];
            let tweenEase: Array<string> = ArrayUtils.stringArray("linear");
            let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

            if (actualCounter != finalCounter) {
                this.messageMultiplier.start(actualCounter, actualCounter + 1, duration, firstDelay);
                this.pickInfoMultiplierNumber.start(
                    finalCounter + 1 - actualCounter,
                    finalCounter - actualCounter - 1,
                    duration * 2,
                );
            }

            tweenValues = this.formatTweenValues("scale.x", ArrayUtils.stringArray("1;1.5;1"));
            tweenDuration = [duration / 4, duration / 4];
            tweenEase = ArrayUtils.stringArray("linear");
            tweenDelay = ArrayUtils.numberArray("0");

            Tweens.removeTweens(this.messageMultiplier, "scale.x");
            Tweens.customTween(this.messageMultiplier, {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1.5;1"));
            Tweens.removeTweens(this.messageMultiplier, "scale.y");
            Tweens.customTween(this.messageMultiplier, {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            actualCounter++;
            let lastDuration: number = duration;
            duration++;

            if (actualCounter == finalCounter) {
                // this._finishPickInfoMultiplierNumber.start(0);
                this.messageMultiplier.makeTween(10);
                this._playMultiplierWinSound.start(10);
            } else {
                if (actualCounter < 4) {
                    PlayList.play("SND_BonusMultiplier1");
                } else if (actualCounter < 7) {
                    PlayList.play("SND_BonusMultiplier2");
                } else {
                    PlayList.play("SND_BonusMultiplier3");
                }
            }

            Tweens.removeTweens(this.messageMultiplier, "changeMessageMultiplierNumber");
            Tweens.customTween(this.messageMultiplier, {
                tween: "changeMessageMultiplierNumber",
                tweenValues: [0, 0],
                tweenDuration: [lastDuration],
                callbackType: "onComplete",
                callbackFunction: this.changeMessageMultiplierNumber,
                callbackScope: this,
                callbackParams: [actualCounter, finalCounter, duration, 0, delay],
                tweenDelay: [firstDelay],
            });
        }
    }

    playMultiplierWinSound(): void {
        this.pickInfoMultiplierNumber.alpha = 0;
        PlayList.play("SND_BonusMultiplierLast");
    }

    intro(long: boolean = false): void {
        StageController.pickStage = true;
        StageController.baseStageContainer.visible = false;
        StageController.freespinsStageContainer.visible = false;
        this.visible = true;

        this.background.addChild(BaseView.Background);
        if (this.teasingEyesContainer != null) {
            this.teasingEyesContainer.addChild(BaseView.TeasingEyes);
        }
        this.fireflies.addChild(BaseView.FireFlies);
        this.machineTop.addChild(BaseView.MachineTop);
        this.messageContainer.addChild(BaseView.Message);
        this.foregroundContainer.addChild(BaseView.Foreground);
        this.transitionScreenContainer.addChild(BaseView.TransitionScreen);
        this.jackContainer.addChild(BaseView.Jack);
        this.logoContainer.addChild(BaseView.Logo);

        this.pickInfoWinNumber.alpha = 0;
        this.pickInfoMultiplierNumber.alpha = 0;
        this.fireflies.visible = true;

        AmbientBackground.changeAmbientBackground("m1", 1050, 3166);

        BaseView.Jack.goToCase("TO_BONUS");
        BaseView.Background.goToCase("TO_BONUS");
        if (BaseView.TeasingEyes != null) {
            BaseView.TeasingEyes.goToCase("TO_BONUS");
        }
        BaseView.Foreground.goToCase("TO_BONUS");
        BaseView.MachineTop.goToCase("TO_BONUS");
        BaseView.Message.goToCase("EMPTY");

        this.spotsContainer.visible = true;

        this.childs["SpotsNumbers"].position.x = 0;

        let cash: SwitchElement = <any>BaseView.Message.getChildElementByName("Cash");
        let multiplier: SwitchElement = <any>BaseView.Message.getChildElementByName("Multiplier");
        let totalCash: SwitchElement = <any>BaseView.Message.getChildElementByName("TotalCash");

        this.messageWin = <any>cash.getChildElementByName("MultiplierNumber");
        this.messageMultiplier = <any>multiplier.getChildElementByName("MultiplierNumber");
        this.messageTotalWin = <any>totalCash.getChildElementByName("MultiplierNumber");

        let tweenValues: Array<number> = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;1;0"));
        let tweenDuration: Array<number> = ArrayUtils.numberArray("30;60");
        let tweenEase: Array<string> = ArrayUtils.stringArray("linear");
        let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

        Tweens.removeTweens(this.fireflies, "alpha");
        tweenValues = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;0;0;0"));
        Tweens.customTween(this.fireflies, {
            tween: "alpha",
            tweenValues,
            tweenEase,
            tweenDuration: [15, 230, 15],
            tweenDelay,
            tweenLoop: false,
        });

        Tweens.removeTweens(this.childs["Spots"], "all");
        tweenValues = [this.childs["Spots"].transitionPositionX, this.childs["Spots"].transitionPositionX, 0];
        Tweens.customTween(this.childs["Spots"], {
            tween: "position.x",
            tweenValues,
            tweenEase: ["linear", "linear"],
            tweenDuration: [60, 200],
            tweenDelay: [0, 0],
            tweenLoop: false,
        });
        this.childs["Spots"].position.y = 0;
        this.childs["SpotsNumbers"].position.y = 0;

        for (let i = 0; i < this.spotsNoWinValuesCounters.length; i++) {
            this.spotsNoWinValuesCounters[i].bitmapText.text = "";
            this.spotsWinValuesCounters[i].bitmapText.text = "";
        }

        for (let i = 0; i < this.multipliersNoWinValuesCounters.length; i++) {
            this.multipliersNoWinValuesCounters[i].bitmapText.text = "";
            this.multipliersWinValuesCounters[i].bitmapText.text = "";
        }

        let initSpotsIndexes = [1, 3, 0, 4, 2];

        for (let i = 0; i < initSpotsIndexes.length; i++) {
            this.spotsContainer.setChildIndex(this.spotsContainer.childs["Spot_" + initSpotsIndexes[i]], i);
        }

        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            //PlayList.stop('SND_FSWinLoop');
            //PlayList.loop('SND_FSpickupMusic');

            this.visible = true;
            this._winAnimator.showSpots(GameManager.pickResponse.round.spots, true);
        }
        this._introDelay.start(360);

        PlayList.loop("SND_BonusLoop", 60);
    }

    /**
     *
     */
    enabledSpots(): void {
        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            this._winAnimator.setSpotsData(GameManager.pickResponse.round.spots);
        }
    }

    introFinished(): void {
        this.enabledSpots();

        StageController.baseStage = false;
        StageController.pickStage = true;

        this.fireflies.visible = false;

        BaseView.Logo.goToCase("BONUS_SHOW");
        this.bonusTable.goToCase("BONUS_1_SHOW");
        PlayList.play("SND_BaseMessageIn");

        this.childs["Spots"].position.x = 0;
        this.childs["SpotsNumbers"].position.x = 0;

        if (this._bonusTable != null && this._bonusTable.classList.contains(HtmlController.DisabledClass)) {
            this._bonusTable.classList.remove(HtmlController.DisabledClass);
        }

        this.visible = true;

        this._winAnimator.startIdleJack();
        this._winAnimator.idleSpots();

        PlayList.stop("SND_FSWait");
        this._controller.introFinished();
    }

    outro(): void {
        this._winAnimator.reset(true);

        this.visible = true;

        BaseView.OutroFrom = "BONUS";
        BaseView.Logo.goToCase("BONUS_OUTRO");

        if (this._bonusTable != null && !this._bonusTable.classList.contains(HtmlController.DisabledClass)) {
            this._bonusTable.classList.add(HtmlController.DisabledClass);
        }

        if (this._pickMessageEnd != null && !this._pickMessageEnd.classList.contains(HtmlController.DisabledClass)) {
            PlayList.play("SND_BaseMessageOut");
            this._pickMessageEnd.classList.add(HtmlController.DisabledClass);
            this._pickMessageEnd.classList.remove("start");
            let msgs: Array<HTMLSpanElement> = <any>this._pickMessageEnd.getElementsByTagName("span");
            for (let i = 0; i < msgs.length; i++) {
                msgs[i].classList.remove("start");
            }
            BaseView.Message.goToCase("EMPTY");
        }

        AmbientBackground.changeAmbientBackground("base", 660, 4000);
        BaseView.Background.goToCase("FROM_BONUS_TO_BASE");
        BaseView.MachineTop.goToCase("FROM_BONUS_TO_BASE");
        BaseView.TransitionScreen.goToCase("FROM_BONUS_TO_BASE");
        BaseView.Foreground.goToCase("FROM_BONUS_TO_BASE");
        BaseView.Jack.goToCase("FROM_BONUS_TO_BASE");

        let tweenValues: Array<number> = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;1;0"));
        let tweenDuration: Array<number> = ArrayUtils.numberArray("30;60");
        let tweenEase: Array<string> = ArrayUtils.stringArray("linear");
        let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

        Tweens.removeTweens(this.fireflies, "alpha");
        tweenValues = this.formatTweenValues("alpha", ArrayUtils.stringArray("0;0;0;1"));
        Tweens.customTween(this.fireflies, {
            tween: "alpha",
            tweenValues,
            tweenEase,
            tweenDuration: [15, 450, 15],
            tweenDelay,
            tweenLoop: false,
        });

        Tweens.removeTweens(this.childs["Multipliers"], "all");
        tweenValues = [0, 0, -this.childs["Spots"].transitionPositionY];
        Tweens.customTween(this.childs["Multipliers"], {
            tween: "position.y",
            tweenValues,
            tweenEase: ["linear", "linear"],
            tweenDuration: [60, 300],
            tweenDelay: [0, 0],
            tweenLoop: false,
        });

        Tweens.removeTweens(this.childs["MultipliersNumber"], "all");
        tweenValues = [0, 0, -this.childs["Spots"].transitionPositionY];
        Tweens.customTween(this.childs["MultipliersNumber"], {
            tween: "position.y",
            tweenValues,
            tweenEase: ["linear", "linear"],
            tweenDuration: [60, 300],
            tweenDelay: [0, 0],
            tweenLoop: false,
        });

        PlayList.stop("SND_BonusLoop");
        PlayList.play("SND_FSTransOut");

        this._outroDelay.start(200);
    }

    outroFinished(): void {
        this._outroDelay.stop();
        this.visible = false;
        this._controller.outroFinished();
    }

    enable(isInit: boolean = false): void {
        PlayList.play("SND_BonusWin");
        PlayList.loop("SND_FSWinLoop");
        PlayList.loop("SND_FSWait");

        if (this._pickMessageStart != null && this._pickMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._pickMessageStart.classList.remove(HtmlController.DisabledClass);
            if (isInit) {
                this._pickMessageStart.classList.add("init");
            } else {
                this._pickMessageStart.classList.add("start");
                PlayList.play("SND_BaseMessageIn");
            }
            BaseView.Message.goToCase("START_MESSAGE_BONUS");
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Pick/PickView.ts
 **/